<div class="animated fadeIn trafficDetail">
  <div class="bs-container-fluid">
  </div>
</div>